/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Catalog_BannerInputs */

const cs_templates_use_catalog_banner = /** @type {(inputs: Templates_Use_Catalog_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona katalogu je připravená. Vygenerovat PDF touto šablonou?`)
};

const en_templates_use_catalog_banner = /** @type {(inputs: Templates_Use_Catalog_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalog template is ready. Generate a PDF with this template?`)
};

/**
* | output |
* | --- |
* | "Catalog template is ready. Generate a PDF with this template?" |
*
* @param {Templates_Use_Catalog_BannerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_catalog_banner = /** @type {((inputs?: Templates_Use_Catalog_BannerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Catalog_BannerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_catalog_banner(inputs)
	return cs_templates_use_catalog_banner(inputs)
});